module.exports = __webpack_public_path__ + "img/mail_verify.3d1fb20a.png";